import React from 'react'
import PropTypes from 'prop-types'
import { confirmText } from '../../../utils/deprecatedSchedule'

/**
 * @deprecated Please delete this file when mpNewSchedulerPage got turned on in prod
 */
export const Confirmed = ({ apptType, stop, stopType }) => {
  const { stopId } = stop
  return (
    <div className='pv5' key={stopId}>
      <strong>Confirmed!</strong>
      <div data-test={`secondary-confirm-text-${stopId}`}>
        {' '}
        {confirmText(stop, stopType, apptType)}{' '}
      </div>
      <div>If you need to make changes, please reply to the email we sent you.</div>
    </div>
  )
}

Confirmed.propTypes = {
  stop: PropTypes.shape({}).isRequired,
  stopType: PropTypes.string.isRequired,
  apptType: PropTypes.string.isRequired,
}
